export default __webpack_public_path__ + "static/tomaszb-8cc8063fa4bb6b51a27f7c39a8b25ad7.jpg";